var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "col-md-12 col-xs-12 col-sm-12" },
      _vm._l(_vm.topTwoServices, function (service, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "col-md-12 col-xs-12 col-sm-12 market-content",
          },
          [
            _c("div", { staticClass: "row market-img" }, [
              _c("div", { staticClass: "pt-4" }, [
                _c("img", {
                  attrs: {
                    src: _vm.getBlobUrl(service.icon_location),
                    alt: "service-icon",
                  },
                }),
              ]),
              _c("div", { staticClass: "col-xs-12" }, [
                _c("div", { staticClass: "mt-5 pl-5" }, [
                  _c(
                    "span",
                    {
                      staticClass: "product-service cursor-pointer",
                      on: {
                        click: function ($event) {
                          return _vm.learnMore(service.id)
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(service.name))])]
                  ),
                  _c("p", { staticClass: "product-content" }, [
                    _vm._v(_vm._s(service.description)),
                  ]),
                ]),
              ]),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "market-title" }, [
      _c("img", {
        staticClass: "marketplace-icon",
        attrs: { src: "/static/images/icons/marketplace_icon_blue.svg" },
      }),
      _c("span", [_vm._v("Marketplace")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }